import RemoveAdsGif from '@/assets/images/plans/RemoveAds.gif';
import extendMaximum from '@/assets/images/plans/ExtendMaximum.gif';
import addedComparisonWithPreviousPeriodToBarchart from '@/assets/images/paidPlan/animation_added_comparison_with_previous_period_to_barchart.webp';
import animationExpandedMaximumNumberOfActivityCalendars from '@/assets/images/paidPlan/animation_expanded_maximum_number_of_activity_calendars.webp';
import animationAnalyticsPageCustomLayout from '@/assets/images/paidPlan/animation_analytics_page_custom_layout.webp';

export type FunctionalDescriptionTranslationKeys = {
    titleKey: string;
    descriptionKey: string;
    imageAltKey: string;
    image: string;
};

/**
 * 機能説明（翻訳キー + 画像）
 */
export const basicPlanFunctionalDescription: FunctionalDescriptionTranslationKeys[] = [
    {
        titleKey: 'functional.items.0.title',
        descriptionKey: 'functional.items.0.description',
        imageAltKey: 'functional.items.0.imageAlt',
        image: extendMaximum,
    },
    {
        titleKey: 'functional.items.1.title',
        descriptionKey: 'functional.items.1.description',
        imageAltKey: 'functional.items.1.imageAlt',
        image: RemoveAdsGif,
    },
    {
        titleKey: 'functional.items.2.title',
        descriptionKey: 'functional.items.2.description',
        imageAltKey: 'functional.items.2.imageAlt',
        image: addedComparisonWithPreviousPeriodToBarchart,
    },
    {
        titleKey: 'functional.items.3.title',
        descriptionKey: 'functional.items.3.description',
        imageAltKey: 'functional.items.3.imageAlt',
        image: animationExpandedMaximumNumberOfActivityCalendars,
    },
    {
        titleKey: 'functional.items.4.title',
        descriptionKey: 'functional.items.4.description',
        imageAltKey: 'functional.items.4.imageAlt',
        image: animationAnalyticsPageCustomLayout,
    },
];
